.wall {
  overflow: hidden;
  /* Breaks out of the page's shared `.container` max-width so the marquee runs wider
     than the rest of the section, without touching the `--container` token every other
     section relies on. The scroll/fade already reads as edge-to-edge, so it's meant to
     span past the text column above it. */
  width: 100vw;
  margin-left: calc(50% - 50vw);
  margin-right: calc(50% - 50vw);
}
.marquee {
  /* Also used by the keyframes, so one loop ends exactly where the duplicate track begins. */
  --rail-gap: var(--sp-10);
  display: flex;
  gap: var(--rail-gap);
  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
}
.track {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: var(--rail-gap);
  animation: scroll 70s linear infinite;
}
/* Mouse only: on a phone a tap leaves `:hover` stuck on, which would freeze the rail. */
@media (hover: hover) {
  .marquee:hover .track {
    animation-play-state: paused;
  }
}
.item img {
  height: 4rem;
  width: auto;
  max-width: 13rem;
  object-fit: contain;
  /* `-mono` assets are white on transparent (scripts/optimize-images.mjs). */
  opacity: 0.7;
  transition: opacity var(--dur) var(--ease);
}
.item:hover img {
  opacity: 1;
}
@keyframes scroll {
  to {
    transform: translateX(calc(-100% - var(--rail-gap)));
  }
}
/* Phones scroll too (they used to get a static grid, which never wrapped and showed ~3 logos);
   the rail is just tighter so more logos fit on screen at once. */
@media (max-width: 47.99rem) {
  .marquee {
    --rail-gap: var(--sp-6);
  }
  .item img {
    height: 2.75rem;
    max-width: 9rem;
  }
}
/* Motion off (OS setting or the site's accessibility panel): all logos as a centered grid. */
@media (prefers-reduced-motion: reduce) {
  .marquee {
    mask-image: none;
    flex-wrap: wrap;
    justify-content: center;
  }
  .track {
    /* Shrinkable, or the track stays one max-content row and `.wall` crops it. */
    flex: 1 1 100%;
    flex-wrap: wrap;
    justify-content: center;
    gap: var(--sp-6);
    animation: none;
  }
  .track[aria-hidden] {
    display: none;
  }
  .item img {
    height: 2.5rem;
  }
}
:global(body.reduced-motion) .marquee {
  mask-image: none;
  flex-wrap: wrap;
  justify-content: center;
}
:global(body.reduced-motion) .track {
  flex: 1 1 100%;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--sp-6);
  animation: none;
}
:global(body.reduced-motion) .track[aria-hidden] {
  display: none;
}
:global(body.reduced-motion) .item img {
  height: 2.5rem;
}
